import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.object.values.js";
var render = function render() {
  var _vm$runningScript$res, _vm$runningScript$res2, _vm$runningScript$res3, _vm$runningScript$res4, _vm$runningScript$res5, _vm$runningScript$res6, _vm$runningScript$res7;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "95%",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Updates according to supplier prices already imported")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.runningScript.result != null ? [_c("div", {
    staticClass: "mt-small"
  }, [_c("div", {
    staticClass: "text-larger text-bold"
  }, [_vm._v("Results")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.ExportResults
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-file-export mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Export results ")], 1), _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v("Wines tested : " + _vm._s(_vm.runningScript.result.nbWinesTotal))])]), ((_vm$runningScript$res = _vm.runningScript.result.cogsUpdateErrors) === null || _vm$runningScript$res === void 0 ? void 0 : _vm$runningScript$res.length) > 0 ? _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v(" Error trying to update : " + _vm._s(_vm.runningScript.result.cogsUpdateErrors.length) + " "), _c(VIcon, {
    staticClass: "cursor--pointer fa fa-eye ml-3",
    on: {
      click: function click($event) {
        _vm.runningScript.showResult.cogsUpdateErrors = !_vm.runningScript.showResult.cogsUpdateErrors;
      }
    }
  })], 1), _vm.runningScript.showResult.cogsUpdateErrors ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.runningScript.headersError,
      items: _vm.runningScript.result.cogsUpdateErrors,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), ((_vm$runningScript$res2 = _vm.runningScript.result.cogsUpdateds) === null || _vm$runningScript$res2 === void 0 ? void 0 : _vm$runningScript$res2.length) > 0 ? _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v(" Cogs updated : " + _vm._s(_vm.runningScript.result.cogsUpdateds.length) + " "), _c(VIcon, {
    staticClass: "cursor--pointer fa fa-eye ml-3",
    on: {
      click: function click($event) {
        _vm.runningScript.showResult.cogsUpdateds = !_vm.runningScript.showResult.cogsUpdateds;
      }
    }
  })], 1), _vm.runningScript.showResult.cogsUpdateds ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.runningScript.headers,
      items: _vm.runningScript.result.cogsUpdateds,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), ((_vm$runningScript$res3 = _vm.runningScript.result.cogsUpdateScheduleds) === null || _vm$runningScript$res3 === void 0 ? void 0 : _vm$runningScript$res3.length) > 0 ? _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v(" Cogs update scheduled : " + _vm._s(_vm.runningScript.result.cogsUpdateScheduleds.length) + " "), _c(VIcon, {
    staticClass: "cursor--pointer fa fa-eye ml-3",
    on: {
      click: function click($event) {
        _vm.runningScript.showResult.cogsUpdateScheduleds = !_vm.runningScript.showResult.cogsUpdateScheduleds;
      }
    }
  })], 1), _vm.runningScript.showResult.cogsUpdateScheduleds ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.runningScript.headers,
      items: _vm.runningScript.result.cogsUpdateScheduleds,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), ((_vm$runningScript$res4 = _vm.runningScript.result.directStocksUpdated) === null || _vm$runningScript$res4 === void 0 ? void 0 : _vm$runningScript$res4.length) > 0 ? _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v(" Stocks updated : " + _vm._s(_vm.runningScript.result.directStocksUpdated.length) + " "), _c(VIcon, {
    staticClass: "cursor--pointer fa fa-eye ml-3",
    on: {
      click: function click($event) {
        _vm.runningScript.showResult.directStocksUpdated = !_vm.runningScript.showResult.directStocksUpdated;
      }
    }
  })], 1), _vm.runningScript.showResult.directStocksUpdated ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.runningScript.headersStock,
      items: _vm.runningScript.result.directStocksUpdated,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), ((_vm$runningScript$res5 = _vm.runningScript.result.directStocksCreated) === null || _vm$runningScript$res5 === void 0 ? void 0 : _vm$runningScript$res5.length) > 0 ? _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v(" Stocks created : " + _vm._s(_vm.runningScript.result.directStocksCreated.length) + " "), _c(VIcon, {
    staticClass: "cursor--pointer fa fa-eye ml-3",
    on: {
      click: function click($event) {
        _vm.runningScript.showResult.directStocksCreated = !_vm.runningScript.showResult.directStocksCreated;
      }
    }
  })], 1), _vm.runningScript.showResult.directStocksCreated ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.runningScript.headersStock,
      items: _vm.runningScript.result.directStocksCreated,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), ((_vm$runningScript$res6 = _vm.runningScript.result.directStocksClosed) === null || _vm$runningScript$res6 === void 0 ? void 0 : _vm$runningScript$res6.length) > 0 ? _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v(" Stocks closed : " + _vm._s(_vm.runningScript.result.directStocksClosed.length) + " "), _c(VIcon, {
    staticClass: "cursor--pointer fa fa-eye ml-3",
    on: {
      click: function click($event) {
        _vm.runningScript.showResult.directStocksClosed = !_vm.runningScript.showResult.directStocksClosed;
      }
    }
  })], 1), _vm.runningScript.showResult.directStocksClosed ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.runningScript.headersStock,
      items: _vm.runningScript.result.directStocksClosed,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), ((_vm$runningScript$res7 = _vm.runningScript.result.winesDeactivated) === null || _vm$runningScript$res7 === void 0 ? void 0 : _vm$runningScript$res7.length) > 0 ? _c("div", {
    staticClass: "mt-small"
  }, [_c("div", [_vm._v(" Products deactivated : " + _vm._s(_vm.runningScript.result.directSwinesDeactivatedocksClosed.length) + " "), _c(VIcon, {
    staticClass: "cursor--pointer fa fa-eye ml-3",
    on: {
      click: function click($event) {
        _vm.runningScript.showResult.winesDeactivated = !_vm.runningScript.showResult.winesDeactivated;
      }
    }
  })], 1), _vm.runningScript.showResult.winesDeactivated ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.runningScript.headersWine,
      items: _vm.runningScript.result.winesDeactivated,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)] : [_c("div", {
    staticClass: "mt-small"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.runningScript.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form, "valid", $$v);
      },
      expression: "runningScript.form.valid"
    }
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.regionsList,
      "item-value": "id",
      "item-text": "name",
      label: "Region of products",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      rules: [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: function change($event) {
        return _vm.changeRegions();
      }
    },
    model: {
      value: _vm.runningScript.form.regionId,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form, "regionId", $$v);
      },
      expression: "runningScript.form.regionId"
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.producerOfRegion,
      "item-value": "id",
      "item-text": "name",
      label: "Producers, let empty for all of region(s)",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.runningScript.form.producerIds,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form, "producerIds", $$v);
      },
      expression: "runningScript.form.producerIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.suppliersList,
      "item-value": "id",
      "item-text": "display_name",
      label: "Prices from file of these suppliers, let empty for all prices",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.runningScript.form.supplierIds,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form, "supplierIds", $$v);
      },
      expression: "runningScript.form.supplierIds"
    }
  }), _c("div", {
    staticClass: "mt-small"
  }, [_c(VCheckbox, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Will update cogs of products",
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.isUpdateCogs,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form, "isUpdateCogs", $$v);
      },
      expression: "runningScript.form.isUpdateCogs"
    }
  }), _vm.runningScript.form.isUpdateCogs ? _c("div", {
    staticClass: "pl-8"
  }, [_c("div", [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isSomeOptionsLocked,
      expression: "!isSomeOptionsLocked"
    }],
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.runningScript.form.updateCogsOptions.isImmediate ? "" : "text-bold"
  }, [_vm._v(" Will schedule a cogs modification ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress || _vm.isSomeOptionsLocked,
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.isImmediate,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "isImmediate", $$v);
      },
      expression: "runningScript.form.updateCogsOptions.isImmediate"
    }
  }), _c("span", {
    class: !_vm.runningScript.form.updateCogsOptions.isImmediate ? "" : "text-bold"
  }, [_vm._v(" Will update cogs immediately during the execution ")])], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.runningScript.form.updateCogsOptions.isImmediate,
      expression: "!runningScript.form.updateCogsOptions.isImmediate"
    }]
  }, [_c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          attrs: {
            disabled: _vm.isAnyActionInProgress,
            type: "date",
            label: "Scheduled date",
            required: "",
            rules: [_vm.formRules.mustNotBeEmpty],
            "hide-details": "auto"
          },
          model: {
            value: _vm.runningScript.form.updateCogsOptions.scheduledDate,
            callback: function callback($$v) {
              _vm.$set(_vm.runningScript.form.updateCogsOptions, "scheduledDate", $$v);
            },
            expression: "runningScript.form.updateCogsOptions.scheduledDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }], null, false, 3485870625),
    model: {
      value: _vm.updateDateCogsMenu,
      callback: function callback($$v) {
        _vm.updateDateCogsMenu = $$v;
      },
      expression: "updateDateCogsMenu"
    }
  }, [_c(VDatePicker, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      min: _vm.minDate
    },
    on: {
      input: function input($event) {
        _vm.updateDateCogsMenu = false;
      }
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.scheduledDate,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "scheduledDate", $$v);
      },
      expression: "runningScript.form.updateCogsOptions.scheduledDate"
    }
  })], 1)], 1)]), _c("div", {
    staticClass: "flex gap-3 mt-small"
  }, [_c(VSelect, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: Object.values(_vm.cogsUpdateTypes),
      "item-value": "id",
      "item-text": "name",
      label: "Cogs value method",
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.typeUpdate,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "typeUpdate", $$v);
      },
      expression: "runningScript.form.updateCogsOptions.typeUpdate"
    }
  }), _vm.runningScript.form.updateCogsOptions.typeUpdate === _vm.cogsUpdateTypes.AVERAGE.id ? _c(VTextField, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Average of nb lower prices (let empty for all prices)",
      "hide-details": "auto",
      type: "number",
      rules: [_vm.formRules.mustBeGreaterThan0OrEmpty]
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.typeAverageNbLower,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "typeAverageNbLower", $$v);
      },
      expression: "runningScript.form.updateCogsOptions.typeAverageNbLower"
    }
  }) : _vm._e()], 1), _c(VTextField, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Apply a percentage on cogs value",
      "hide-details": "auto",
      type: "text"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKeyAllowNegative
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.modifierPercentage,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "modifierPercentage", $$v);
      },
      expression: "runningScript.form.updateCogsOptions.modifierPercentage"
    }
  }), _c("div", {
    staticClass: "display-switch mt-small"
  }, [_c("span", {
    class: _vm.runningScript.form.updateCogsOptions.isPreventModificationWithConditionalDiscount ? "" : "text-bold"
  }, [_vm._v(" Will update cogs EVEN IF the product has conditional discount ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.isPreventModificationWithConditionalDiscount,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "isPreventModificationWithConditionalDiscount", $$v);
      },
      expression: "\n                          runningScript.form.updateCogsOptions\n                            .isPreventModificationWithConditionalDiscount\n                        "
    }
  }), _c("span", {
    class: !_vm.runningScript.form.updateCogsOptions.isPreventModificationWithConditionalDiscount ? "" : "text-bold"
  }, [_vm._v(" Will NOT update cogs if the product has conditional discount ")])], 1), _c("div", {
    staticClass: "mt-small"
  }, [_c("div", {
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.runningScript.form.updateCogsOptions.isPreventModificationWithWarehouseStock ? "" : "text-bold"
  }, [_vm._v(" Will update cogs EVEN IF product has a warehouse stock ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.isPreventModificationWithWarehouseStock,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "isPreventModificationWithWarehouseStock", $$v);
      },
      expression: "\n                            runningScript.form.updateCogsOptions\n                              .isPreventModificationWithWarehouseStock\n                          "
    }
  }), _c("span", {
    class: !_vm.runningScript.form.updateCogsOptions.isPreventModificationWithWarehouseStock ? "" : "text-bold"
  }, [_vm._v(" Will NOT update cogs if product has a warehouse stock ")])], 1), _vm.runningScript.form.updateCogsOptions.isPreventModificationWithWarehouseStock ? _c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.warehousesList,
      "item-value": "id_warehouse",
      "item-text": "name",
      label: "Warehouse storage preventing cogs update, let empty for all",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.preventModificationForWarehouseIds,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "preventModificationForWarehouseIds", $$v);
      },
      expression: "\n                          runningScript.form.updateCogsOptions.preventModificationForWarehouseIds\n                        "
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "mt-small"
  }, [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.winesList,
      "item-value": "id_wine",
      "item-text": "display_name",
      label: "Specific wines prevented to have their cogs updated",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.runningScript.form.updateCogsOptions.preventModificationOnWineIds,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateCogsOptions, "preventModificationOnWineIds", $$v);
      },
      expression: "\n                          runningScript.form.updateCogsOptions.preventModificationOnWineIds\n                        "
    }
  })], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "mt-small"
  }, [_c(VCheckbox, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      label: "Will update direct winery stock quantities",
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.isUpdateDirectProducerStockQuantities,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form, "isUpdateDirectProducerStockQuantities", $$v);
      },
      expression: "runningScript.form.isUpdateDirectProducerStockQuantities"
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.runningScript.form.isUpdateDirectProducerStockQuantities,
      expression: "runningScript.form.isUpdateDirectProducerStockQuantities"
    }],
    staticClass: "pl-8"
  }, [_c("div", {
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isPreventProductsDown ? "" : "text-bold"
  }, [_vm._v(" Will NOT prevent to lower stocks of matching wines ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isPreventProductsDown,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions, "isPreventProductsDown", $$v);
      },
      expression: "\n                          runningScript.form.updateDirectProducerStockQuantitiesOptions\n                            .isPreventProductsDown\n                        "
    }
  }), _c("span", {
    class: !_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isPreventProductsDown ? "" : "text-bold"
  }, [_vm._v(" Will PREVENT to lower stocks of matching wines ")])], 1), _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isPreventProductsDown ? _c("div", {
    staticClass: "mb-3 pl-5"
  }, [_c("div", {
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.isMatchAllOptions ? "" : "text-bold"
  }, [_vm._v(" Prevent wines that match ONE FILTER ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.isMatchAllOptions,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions, "isMatchAllOptions", $$v);
      },
      expression: "\n                            runningScript.form.updateDirectProducerStockQuantitiesOptions\n                              .preventProductsDownOptions.isMatchAllOptions\n                          "
    }
  }), _c("span", {
    class: !_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.isMatchAllOptions ? "" : "text-bold"
  }, [_vm._v(" Prevent wines that match ALL FILTERS ")])], 1), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.vintagesList,
      "item-value": "id",
      "item-text": "name",
      label: "Vintages prevented to get their direct stock lowered",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.vintages,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions, "vintages", $$v);
      },
      expression: "\n                          runningScript.form.updateDirectProducerStockQuantitiesOptions\n                            .preventProductsDownOptions.vintages\n                        "
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.suppliersList,
      "item-value": "id",
      "item-text": "display_name",
      label: "Prevent wines from these suppliers to get their direct stock lowered",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.producerIds,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions, "producerIds", $$v);
      },
      expression: "\n                          runningScript.form.updateDirectProducerStockQuantitiesOptions\n                            .preventProductsDownOptions.producerIds\n                        "
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      items: _vm.winesList,
      "item-value": "id_wine",
      "item-text": "display_name",
      label: "Specific wines prevented to get their direct stock lowered",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.productIds,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions, "productIds", $$v);
      },
      expression: "\n                          runningScript.form.updateDirectProducerStockQuantitiesOptions\n                            .preventProductsDownOptions.productIds\n                        "
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isCloseDirectProducerStocksWithoutSupplierPrice ? "" : "text-bold"
  }, [_vm._v(" Will NOT close direct producer stocks that have not any supplier price available ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isCloseDirectProducerStocksWithoutSupplierPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions, "isCloseDirectProducerStocksWithoutSupplierPrice", $$v);
      },
      expression: "\n                          runningScript.form.updateDirectProducerStockQuantitiesOptions\n                            .isCloseDirectProducerStocksWithoutSupplierPrice\n                        "
    }
  }), _c("span", {
    class: !_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isCloseDirectProducerStocksWithoutSupplierPrice ? "" : "text-bold"
  }, [_vm._v(" Will CLOSE direct producer stocks that have not any supplier price available ")])], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isCloseDirectProducerStocksWithoutSupplierPrice,
      expression: "\n                        runningScript.form.updateDirectProducerStockQuantitiesOptions\n                          .isCloseDirectProducerStocksWithoutSupplierPrice\n                      "
    }],
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isDeactivateProductsWithoutSupplierPriceWithoutWarehouseStock ? "" : "text-bold"
  }, [_vm._v(" Will NOT deactivate products that have not any supplier price available, or stock ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      "hide-details": "auto"
    },
    model: {
      value: _vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isDeactivateProductsWithoutSupplierPriceWithoutWarehouseStock,
      callback: function callback($$v) {
        _vm.$set(_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions, "isDeactivateProductsWithoutSupplierPriceWithoutWarehouseStock", $$v);
      },
      expression: "\n                          runningScript.form.updateDirectProducerStockQuantitiesOptions\n                            .isDeactivateProductsWithoutSupplierPriceWithoutWarehouseStock\n                        "
    }
  }), _c("span", {
    class: !_vm.runningScript.form.updateDirectProducerStockQuantitiesOptions.isDeactivateProductsWithoutSupplierPriceWithoutWarehouseStock ? "" : "text-bold"
  }, [_vm._v(" Will DEACTIVATE products that have not any supplier price available, or stock ")])], 1)])], 1)], 1)])], 1), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.runningScript.isPending,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.confirmRunScript();
      }
    }
  }, [_vm._v(" Execute updates ")]), _vm.runningScript.isPending ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancelRunningScript();
      }
    }
  }, [_vm._v(" Cancel updates ")]) : _vm._e()], 1)]], 2)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };